<template>
  <div class="tai-xiu-big-small">
    <Row class="tai-xiu-big-small-container" type="flex">
      <new-bet-lot
        v-for="item in games"
        class="tai-xiu-big-small-betlot"
        :type="item"
        :win="winCellNo === item"
        :odd="odd(item)"
        :game="game"
        gameType="tai_xiu"
        :game-data="gameData"
        :minutes-string="minutesString"
        :seconds-string="secondsString"
        :disallow-betting="disallowBetting"
        :stake-record-sum="stakeRecordSum(item)"
        @update-session-storage="onUpdateSessionStorage"
        size="large"
      />
    </Row>
  </div>
</template>

<script>
import { Row, Col, Button } from "iview";
import NewBetLot from "../../commons/NewBetLot";
import betLotMixin from "../../../mixins/bet-lot-mixin";

export default {
  mixins: [betLotMixin],
  props: ["game", "winCellNo", "gameData"],
  components: {
    Row,
    Col,
    Button,
    NewBetLot
  },
  data() {
    return {
      games: ["o1", "o3", "o2"]
    };
  }
};
</script>


<style lang="scss" scoped>
.tai-xiu-big-small {
  @extend .game-section;
  background: #75665f;
}

.tai-xiu-big-small-betlot {
  flex: 1;
}

.tai-xiu-big-small-betlot:first-of-type {
  margin-left: unset;
  border-radius: 4px 0 0 4px;
}

.tai-xiu-big-small-betlot:last-of-type {
  margin-right: unset;
}
</style>

